import { generateRandomNumber } from '..';

const randomNumberLimit = 10000;
const generateUploadId = () => generateRandomNumber(randomNumberLimit);

export default generateUploadId;
